import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CompanyType } from "@green0meter/api-client";

import { CompanyEditorFieldProps } from "../../CompanyEditor.types";

import { TextField, Typography, Autocomplete } from "@components/base";

const CompanyTypeField: FC<CompanyEditorFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary">
        {t("entities.table.column.type")}
      </Typography>
      <Controller
        name="companyType"
        control={control}
        render={({ field }) => (
          <Autocomplete
            options={[
              CompanyType.Master,
              CompanyType.Subsidiary,
              CompanyType.Asset,
              CompanyType.Supplier,
            ]}
            getOptionLabel={(option) => CompanyType[option]}
            value={field.value}
            onChange={(_event, newValue) => {
              if (newValue !== null) field.onChange(newValue);
            }}
            isOptionEqualToValue={(option, value) => option === value}
            disabled
            renderInput={(params) => (
              <TextField
                {...params}
                variant="filled"
                placeholder={t("entities.table.column.type")}
              />
            )}
          />
        )}
      />
    </>
  );
};

export default CompanyTypeField;
